// ./hooks/useDataFetching.js
import { useEffect, useState, useRef } from "react";

export const useDataFetching = ({
  fetchFn,
  officeCode,
  pagination = { currentPage: 1, perPage: 15 },
  filters,
  onSuccess,
  onError,
}) => {
  const [refreshCounter, setRefreshCounter] = useState(0);
  const successRef = useRef(onSuccess);
  const errorRef = useRef(onError);

  // 保持最新回调引用
  useEffect(() => {
    successRef.current = onSuccess;
    errorRef.current = onError;
  }, [onSuccess, onError]);

  const refetch = () => {
    setRefreshCounter((prev) => prev + 1);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const queryParams = {
          page: pagination.currentPage - 1,
          size: pagination.perPage,
        };

        const response = await fetchFn(officeCode, filters, {
          params: queryParams,
        });

        // 使用ref访问最新回调
        if (typeof successRef.current === "function") {
          successRef.current(response.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        if (typeof errorRef.current === "function") {
          errorRef.current(error);
        }
      }
    };

    fetchData();
  }, [
    fetchFn,
    officeCode,
    pagination.currentPage, // 保持细粒度依赖
    pagination.perPage,
    filters,
    refreshCounter, // 保留手动刷新机制
    // 移除 onSuccess/onError 依赖
  ]);

  return { refetch };
};
